import { gql } from 'graphql-tag';

const GET_UNIVERSITY = gql`
	query getUniversity($uniSlug: String!) {
		university(slug: $uniSlug) {
			id
			name
			slug
			logo
			paid_features
			order
			stats {
				rating
			}
			privacy_policy_url
			undergraduate: profile(product: UNDERGRADUATE) {
				external_url
				external_prospectus_url
				cover_image
				external_events_url
			}
			postgraduate: profile(product: POSTGRADUATE) {
				external_url
				external_prospectus_url
				cover_image
				external_events_url
			}
		}
		universityGallery(university: $uniSlug) {
			images {
				path
				position
			}
		}
	}
`;

const GET_COURSE = gql`
	query getCourse($courseSlug: String!) {
		course(slug: $courseSlug) {
			id
			slug
			name
			university
			overview
			academic_year
			product
			external_url
			external_scholarships_url
			code
			institution_code
			options {
				study_mode
				duration
				start_date
				campus {
					name
					address
				}
				entry_years
				entry_requirements {
					type
					acceptable
					min_entry
					max_entry
					information
				}
				fees {
					price
					currency
					region
					state
					period
				}
				application_deadline
				external_url
			}
			location {
				address
				postcode
				country
				maps
			}
			saved
		}
	}
`;

const GET_CLEARING_UNIVERSITY = gql`
	query getClearingUniversity($uniSlug: String!) {
		clearingUniversity(slug: $uniSlug) {
			id
			name
			slug
			logo
			paid_features
			external_url
			privacy_policy_url
			saved
			cover_image
			gallery {
				path
				position
			}
			overview
			usp
			order
		}
	}
`;

const GET_CLEARING_COURSE = gql`
	query getClearingCourse($courseSlug: String!) {
		clearingCourse(slug: $courseSlug) {
			id
			slug
			name
			university
			overview
			academic_year
			external_url
			external_scholarships_url
			code
			institution_code
			options {
				study_mode
				duration
				start_date
				campus {
					name
					address
				}
				entry_years
				entry_requirements {
					type
					acceptable
					min_entry
					max_entry
					information
				}
				fees {
					price
					currency
					region
					state
					period
				}
				application_deadline
				external_url
			}
			location {
				address
				postcode
				country
				maps
			}
			phone_number
			saved
		}
	}
`;

export { GET_UNIVERSITY, GET_COURSE, GET_CLEARING_UNIVERSITY, GET_CLEARING_COURSE };
